import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Modal } from "react-bootstrap";
import parse from "html-react-parser";
import { toast } from "react-toastify";

import {
  cardUpgradeData,
  paymentSuccessfulData,
} from "../ImageAndDataPopUp/DataContent";
import { toastResponse } from "../../Toast/Toast";
import { _get } from "../../../../api/apiClient";

import "./imageAndDataPopUp.scss";
import { formatCategoryName } from "../../../Bank/widget/widgetsCommonFunction";
import { LogOut } from "../../../../Redux/authSlice";
import moment from "moment";
import { setLoaderFalse } from "../../../../Redux/loaderSlice";
import { getFormattedDateType1 } from "../../../Bank/CampaignManagement/campaignConstant";
import { SUBSCRIPTION } from "../../../../utils/global";
import PropTypes from "prop-types";
import exportimages from "../../../../assets/images/exportImages";
import { setForceLogout } from "../../../../rtk-query/features/stripe/stripeSlice";

const getPopupDescClass = (cardName) => {
  const lowerCardName = cardName?.toLowerCase();
  if (lowerCardName === "insights and strategy") {
    return "popupDesc EWIpopupDesc";
  }
  if (lowerCardName === "sales_contacted_successfully") {
    return "popupDesc contactSuccess";
  }
  return "popupDesc";
};

const getInvolvedTier = (existingTier) => {
  if (existingTier === "Freemium") {
    return "Pro";
  }
  if (existingTier === "Pro") {
    return "Marketing";
  }
  return "Pro";
};

const shouldShowUpgradeButton = (userRole, subscription) => {
  const isNotRestrictedRole =
    userRole !== "reseller" && userRole !== "bond-admin";
  const isNotProSubscription = subscription !== SUBSCRIPTION.PRO;
  return isNotRestrictedRole && isNotProSubscription;
};

const shouldShowLogoutButton = (userRole, maintenanceIsDown) => {
  if (maintenanceIsDown) {
    return true;
  }
  return userRole !== "reseller" && userRole !== "bond-admin";
};

export const ImageAndDataPopUp = ({
  onHide = () => {},
  show,
  modalData,
  triggredFrom,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer);
  const userRole = authReducer?.userData?.role?.toLowerCase();
  const showLogoutButton = modalData?.showLogoutButton || false;
  const showAriaButton = modalData?.showAriaButton || false;
  const [popupData, setPopupData] = useState(modalData);
  const [loading, setLoading] = useState(false);
  const [queryParams] = useSearchParams();
  const payment_successful = queryParams.get("payment_successful");
  const { data: maintenanceData } = useSelector(
    (state) => state?.maintenanceReducer?.maintenanceData,
  );
  const trialEndTimeStamp = useSelector(
    (state) => state?.stripeReducer?.acknowledgement?.trial_end,
  );
  const idrssd = useSelector((state) => state?.orgReducer?.selectedFI?.idrssd);

  const timestampUTC =
    trialEndTimeStamp == null
      ? null
      : moment.unix(trialEndTimeStamp).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
  const handleClick = async () => {
    let existing = authReducer?.userData?.subscriptionName;
    let involved = getInvolvedTier(existing);

    setLoading(true);
    try {
      const response = await _get(
        `/client/pro/request?vFeature=${triggredFrom ?? formatCategoryName(popupData.cardName)}&vExistingTier=${existing}&vInvolvedTier=${involved}`,
      );
      if (response.data.status === "SUCCESS") {
        setPopupData(
          cardUpgradeData?.find(
            (i) => i?.cardName === "sales_contacted_successfully",
          ),
        );
      }
    } catch (error) {
      toast.error(toastResponse("error", error?.data?.message));
    }
    setLoading(false);
  };

  const handleFnAnalystFlow = async () => {
    dispatch(setForceLogout(false));
    navigate(`/bank/health-analysis/report/${idrssd}/ewiChatBot/aria`);
  };

  const handleSchedule = () => {
    const clientId = authReducer?.userData?.client_Id;

    if (!clientId) {
      console.error("client_Id missing");
      return;
    }

    const baseUrl = process.env.REACT_APP_MEETING_BASE_URL;

    // open at same tab
    //window.location.href = `${baseUrl}?uuid=${clientId}`;

    // Open in new tab
    window.open(`${baseUrl}?uuid=${clientId}`, "_blank");

    // Close popup first
    onHide();

    //Navigate current tab
    const id = authReducer?.userData?.idrssd;
    navigate(`/bank/health-analysis/report/${id}/ewiChatBot/aria`);
  };

  return (
    <Modal
      className="imageAndDataPopup"
      show={show}
      onHide={() => {
        onHide();
      }}
      size={`${modalData?.cardName?.toLowerCase() === "upgrade_to_autopilot_profit" ? "xl" : "lg"}`}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="p-0 h-100">
        <div className="popup-content d-flex h-100">
          <div className="popup-media">
            <img
              src={popupData?.popupImage}
              alt={popupData?.popupHeader || "Popup illustration"}
              className="popup-image"
            />
          </div>
          <div className="popup_details_block">
            <div>
              <button
                type="button"
                className={
                  popupData?.cardName === paymentSuccessfulData?.cardName
                    ? "d-none"
                    : "d-block close btn-close float-end"
                }
                aria-label="Close"
                onClick={() => {
                  onHide();
                }}
              >
                <span aria-hidden="true" className="visually-hidden">
                  &times;
                </span>
              </button>
            </div>

            {/* <label
              style={{
                marginTop:
                  popupData?.cardName?.toLowerCase() === "insights and strategy"
                    ? "0"
                    : "1.154rem",
              }}
            >
              {popupData?.popupHeader}
            </label> */}

            {popupData?.cardName === "consultation_payment_successful" && (
              <img
                src={exportimages?.payment_successful_icon}
                alt="payment_successful_icon"
                className="img-fluid d-block"
              />
            )}

            {popupData?.cardName !== "payment_schedule" && (
              <label
                style={{
                  marginTop:
                    popupData?.cardName?.toLowerCase() ===
                    "insights and strategy"
                      ? "0"
                      : "1.154rem",
                }}
              >
                {popupData?.popupHeader}
              </label>
            )}

            <div className={getPopupDescClass(popupData?.cardName)}>
              {parse(String(popupData?.popupDescription || ""))}
            </div>
            {popupData?.showTrialPeriod &&
              timestampUTC &&
              payment_successful !== "true" && (
                <div className="popupDesc">
                  <br />
                  <p>
                    Your subscription ends on{" "}
                    {getFormattedDateType1(timestampUTC)} !
                  </p>
                </div>
              )}
            {popupData?.showUpgradeButton &&
              shouldShowUpgradeButton(
                userRole,
                authReducer?.userData?.subscription,
              ) && (
                <button
                  type="button"
                  style={{ marginTop: "2.625rem" }}
                  onClick={() => handleClick()}
                  className="btn btn-other btn-bond fw-bolder btn-lg btn-popup"
                >
                  <span className="fs-btn-text fw-normal">
                    Upgrade to Autopilot Profit
                  </span>
                  <i
                    className="spinner-grow spinner-grow-sm ms-3"
                    id="btn_spinner"
                    aria-hidden={!loading}
                    style={{ display: loading ? "inline-flex" : "none" }}
                  />
                </button>
              )}

            {showAriaButton && (
              <button
                type="button"
                style={{ marginTop: "2.625rem" }}
                onClick={handleFnAnalystFlow}
                className="btn btn-other btn-bond fw-bolder btn-lg btn-popup"
              >
                <span className="fs-btn-text fw-normal">Start Exploring</span>
              </button>
            )}

            {showLogoutButton &&
              shouldShowLogoutButton(
                userRole,
                maintenanceData?.is_downtime,
              ) && (
                <button
                  type="button"
                  style={{ marginTop: "2.625rem" }}
                  onClick={async () =>
                    await dispatch(LogOut())
                      .unwrap()
                      .then(() => {
                        dispatch(setLoaderFalse());
                        navigate("/user/login");
                      })
                      .catch(() => {
                        dispatch(setLoaderFalse());
                      })
                  }
                  className="btn btn-other btn-bond fw-bolder btn-lg btn-popup"
                >
                  <span className="fs-btn-text fw-normal">Sign out</span>
                  <i
                    className="spinner-grow spinner-grow-sm ms-3"
                    id="btn_spinner"
                    aria-hidden={!loading}
                    style={{ display: loading ? "inline-flex" : "none" }}
                  />
                </button>
              )}

            {popupData?.showScheduleButtons && (
              <div className="schedule-actions">
                <button
                  type="button"
                  className="btn btn-bond btn-primary btn-popup"
                  onClick={handleSchedule}
                >
                  Schedule Now
                </button>

                <button
                  type="button"
                  className="btn btn-outline-primary btn-popup"
                  onClick={() => {
                    onHide();
                    const id = authReducer?.userData?.idrssd;
                    navigate(
                      `/bank/health-analysis/report/${id}/ewiChatBot/aria`,
                    );
                  }}
                >
                  Schedule Later
                </button>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

ImageAndDataPopUp.propTypes = {
  onHide: PropTypes.func,
  show: PropTypes.bool.isRequired,
  modalData: PropTypes.shape({
    cardName: PropTypes.string.isRequired,
    showLogoutButton: PropTypes.bool,
    showUpgradeButton: PropTypes.bool,
    popupImage: PropTypes.string,
    popupHeader: PropTypes.string,
    popupDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    showTrialPeriod: PropTypes.bool,
    showScheduleButtons: PropTypes.bool,
  }).isRequired,
  triggredFrom: PropTypes.string,
};
